<template>
    <v-app id="inspire">
        <v-snackbar v-model="flag" top color="error top-element" v-if="!validReset">
            {{ message }}
            <v-btn color="white" text @click="flag = false">
                Close
            </v-btn>
        </v-snackbar>

        <div class="login-container">
            <div class="login-background">
                <div class="background-pattern"></div>
                <div class="background-gradient"></div>
            </div>
            
            <v-container fluid class="login-content">
                <v-row no-gutters class="min-height-100vh">
                    <v-col cols="12" sm="12" md="6" class="logo-column d-none d-md-flex">
                        <div class="logo-content">
                            <v-img 
                                src="../assets/crx-main-logo.png" 
                                class="main-logo"
                                contain
                            ></v-img>
                            <p class="app-version">v.1.5.3.2025</p>
                        </div>
                    </v-col>
                    
                    <v-col cols="12" sm="12" md="6" class="login-column">
                        <div class="login-container-inner">
                            <div class="login-form-wrapper">
                                <!-- Back Button -->
                                <div class="back-button-container">
                                    <v-btn
                                        icon
                                        color="rgba(255, 255, 255, 0.8)"
                                        size="large"
                                        @click="$router.push('/')"
                                        class="back-btn"
                                    >
                                        <v-icon>mdi-arrow-left</v-icon>
                                    </v-btn>
                                </div>
                                
                                <div class="mobile-logo-top d-md-none">
                                    <v-img 
                                        src="../assets/crx-main-logo-1.png" 
                                        class="mobile-top-logo"
                                        contain
                                    ></v-img>
                                </div>
                                
                                <div v-if="validReset" class="login-form success-state">
                                    <div class="text-center mb-6">
                                        <v-icon size="64" color="success" class="mb-4">
                                            mdi-email-check
                                        </v-icon>
                                        <h2 class="text-h5 text-white mb-4">Email Sent Successfully</h2>
                                        <p class="text-body-1 text-white">
                                            An email has been sent to 
                                            <span class="font-weight-bold">{{ message }}</span> 
                                            with further instructions.
                                        </p>
                                    </div>
                                    
                                    <v-btn
                                        class="signin-btn text-uppercase"
                                        color="primary"
                                        size="x-large"
                                        variant="flat"
                                        block
                                        @click="$router.push('/')"
                                    >
                                        Back to Login
                                    </v-btn>
                                </div>
                                
                                <v-form
                                    v-else
                                    ref="form"
                                    v-model="valid"
                                    lazy-validation
                                    class="login-form"
                                >
                                    <div class="text-center mb-6">
                                        <h2 class="text-h5 text-white mb-2">Reset Your Password</h2>
                                        <p class="text-body-2 text-white" style="opacity: 0.8;">
                                            Enter your email address and we'll send you instructions to reset your password
                                        </p>
                                    </div>
                                    
                                    <div class="input-group">
                                        <v-text-field
                                            name="email"
                                            label="Email Address"
                                            required
                                            v-model="email"
                                            :rules="emailRules"
                                            prepend-inner-icon="mdi-email-outline"
                                            type="email"
                                            variant="outlined"
                                            class="form-input"
                                            color="primary"
                                            v-on:keydown.enter.prevent="onEnterKey"
                                            autocomplete="email"
                                            hide-details="auto"
                                        ></v-text-field>
                                    </div>
                                    
                                    <v-btn
                                        class="signin-btn text-uppercase"
                                        color="primary"
                                        size="x-large"
                                        variant="flat"
                                        block
                                        :loading="loading"
                                        @click="sendPasswordResetInstructions"
                                    >
                                        Send Reset Instructions
                                    </v-btn>
                                    
                                    <div class="text-center mt-4">
                                        <router-link to="/" class="back-link">
                                            ← Back to Login
                                        </router-link>
                                    </div>
                                </v-form>
                                
                                <div class="mobile-version-bottom d-md-none">
                                    <p class="mobile-version">v.1.5.3.2025</p>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </v-app>
</template>

<script>
  import { mapActions } from "vuex";

  export default {
    name: "ForgotPassword",
    data() {
      return {
        valid: true,
        loading: false,
        flag: false,
        email: "",
        message: "",
        emailRules: [
          (v) => !!v || "E-mail is required",
          (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
        ],
        validReset: false,
      }
    },
    methods: {
      ...mapActions(["resetPassword"]),

      validate() {
        return this.$refs.form.validate();
      },

      onEnterKey: function(e) {
        if (e.keyCode === 13) {
          this.sendPasswordResetInstructions();
        }
      },

      sendPasswordResetInstructions() {
        this.loading = true;

        if (this.validate()) {
          this.resetPassword({ Email: this.email })
            .then((res) => {
              if (!res.data.success) {
                this.flag = true;
                this.loading = false;
                this.message = res.data.msg;

                return;
              } else {
                this.loading = false;
                this.validReset = true;
                this.message = res.data.msg;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.loading = false;
        }
      }
    }
  }
</script>
<style scoped>
.login-container {
    position: relative;
    min-height: 100vh;
    overflow: hidden;
    padding: 0px;
}

.login-background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
}

.background-gradient {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f8fafc;
}

.background-pattern {
    display: none;
}

.login-content {
    position: relative;
    z-index: 1;
    min-height: 100vh;
    padding: 0 !important;
}

.min-height-100vh {
    min-height: 100vh;
}

.logo-content {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    z-index: 1;
    position: relative;
}

.app-version {
    font-size: 1.5rem;
    font-weight: 400;
    color: #2b3990;
    margin: 0;
    font-family: 'Inter', 'Segoe UI', system-ui, sans-serif;
    letter-spacing: 0.5px;
}

.logo-column {
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    position: relative;
}

.logo-column::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(45deg, rgba(43, 57, 144, 0.02) 0%, transparent 100%);
    pointer-events: none;
}

.main-logo {
    opacity: 0.95;
    filter: drop-shadow(0 4px 16px rgba(43, 57, 144, 0.15));
    width: 90%;
    max-width: 600px;
    height: auto;
    min-width: 200px;
}

.main-logo :deep(.v-img__img) {
    object-fit: contain;
    width: 100%;
    height: auto;
}

.login-container-inner {
    width: 100%;
    max-width: 450px;
}

.login-form-wrapper {
    padding: 0;
    margin: 20px;
}

.login-column {
    background: linear-gradient(135deg, #2b3990 0%, #1e2a73 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 2rem;
}

.input-group {
    position: relative;
    margin-bottom: 1.5rem;
}

/* Mobile logo and version */
.mobile-logo-top {
    text-align: center;
    margin-bottom: 1.5rem;
}

.mobile-top-logo {
    width: 234px;
    height: auto;
    opacity: 0.9;
    margin: 0 auto;
}

.mobile-version-bottom {
    text-align: center;
    margin-top: 1.5rem;
    padding-top: 1.25rem;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.mobile-version {
    font-size: 0.875rem;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
    font-weight: 400;
}

.login-form {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    margin: 1.5rem 0;
    padding: 2rem;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.success-state {
    text-align: center;
}

.form-input {
    margin-bottom: 1.5rem;
}

.form-input :deep(.v-field) {
    border-radius: 8px;
    background: #fafbfc;
    border: 1px solid #d0d7de;
}

.form-input :deep(.v-field--focused) {
    background: white;
    border-color: #2b3990;
    box-shadow: 0 0 0 3px rgba(43, 57, 144, 0.1);
}

.form-input :deep(.v-field--error) {
    border-color: #dc2626;
    box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
}

.form-input :deep(.v-field__input) {
    padding: 0.75rem;
    font-size: 1rem;
    color: #374151;
    font-weight: 500;
}

.form-input :deep(.v-label) {
    font-weight: 500;
    color: #6b7280;
}

.form-input :deep(.v-field__prepend-inner) {
    color: #6b7280;
    margin-right: 0.75rem;
}

.back-link {
    color: #2b3990 !important;
    text-decoration: none;
    font-size: 0.875rem;
    font-weight: 500;
    transition: all 0.2s ease;
}

.back-link:hover {
    color: #1e2a73 !important;
    text-decoration: underline;
}

.signin-btn {
    background: linear-gradient(135deg, #2b3990 0%, #1e2a73 100%) !important;
    color: white !important;
    border-radius: 8px !important;
    font-weight: 600 !important;
    font-size: 1rem !important;
    text-transform: uppercase !important;
    letter-spacing: 0.025em !important;
    box-shadow: 
        0 8px 20px rgba(43, 57, 144, 0.3),
        0 4px 10px rgba(43, 57, 144, 0.2) !important;
    margin-top: 1rem;
}

.top-element {
    z-index: 9999;
}

/* Back button styling */
.back-button-container {
    position: absolute;
    top: 1.5rem;
    left: 1.5rem;
    z-index: 10;
}

.back-btn {
    background: rgba(255, 255, 255, 0.1) !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    backdrop-filter: blur(10px);
    transition: all 0.2s ease;
}

.back-btn:hover {
    background: rgba(255, 255, 255, 0.2) !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
    transform: translateX(-2px);
}

/* Responsive design */
@media (max-width: 1400px) {
    .main-logo {
        width: 85%;
        max-width: 500px;
    }
}

@media (max-width: 1200px) {
    .main-logo {
        width: 80%;
        max-width: 450px;
    }
    
    .app-version {
        font-size: 1.4rem;
    }
}

/* Tablet and below - Stack vertically */
@media (max-width: 960px) {
    .logo-column {
        min-height: 35vh;
        padding: 2rem 1rem 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .login-column {
        min-height: 65vh;
        padding: 1rem;
        background: linear-gradient(135deg, #2b3990 0%, #1e2a73 100%);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .main-logo {
        width: 75%;
        max-width: 400px;
        min-width: 250px;
    }
    
    .app-version {
        font-size: 1.3rem;
    }
    
    .logo-content {
        gap: 1.5rem;
    }
}

@media (max-width: 768px) {
    .logo-column {
        min-height: 30vh;
        padding: 1.5rem 1rem 0.5rem;
    }
    
    .login-column {
        min-height: 70vh;
        padding: 0.5rem 1rem 1rem;
    }
    
    .main-logo {
        width: 70%;
        max-width: 320px;
        min-width: 200px;
    }
    
    .app-version {
        font-size: 1.2rem;
    }
}

/* Mobile phones */
@media (max-width: 960px) {
    .login-column {
        min-height: 100vh;
        padding: 2rem 1.5rem 1.5rem;
        background: linear-gradient(135deg, #2b3990 0%, #1e2a73 100%);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .login-form {
        padding: 1.75rem;
        border-radius: 14px;
        background: rgba(255, 255, 255, 0.95);
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
        margin: 1rem 0;
    }
    
    .form-input :deep(.v-field) {
        border-radius: 12px;
        background: #f9fafb;
        border: 2px solid #e5e7eb;
        min-height: 48px;
    }
    
    .form-input :deep(.v-field--focused) {
        background: white;
        border-color: #2b3990;
        box-shadow: 0 0 0 4px rgba(43, 57, 144, 0.1);
    }
    
    .form-input :deep(.v-field__input) {
        padding: 0.875rem;
        font-size: 1rem;
        color: #1f2937;
        font-weight: 500;
    }
    
    .form-input :deep(.v-label) {
        font-size: 1rem;
        font-weight: 600;
        color: #6b7280;
    }
    
    .form-input :deep(.v-field__prepend-inner) {
        color: #6b7280;
        margin-right: 1rem;
        font-size: 1.25rem;
    }
    
    .signin-btn {
        min-height: 48px !important;
        font-size: 1.05rem !important;
        font-weight: 700 !important;
        border-radius: 12px !important;
        margin: 1.5rem 0 1rem 0;
        box-shadow: 0 8px 24px rgba(43, 57, 144, 0.25) !important;
    }
}

/* Small mobile phones */
@media (max-width: 480px) {
    .login-column {
        padding: 1.5rem 1.25rem 1.25rem;
    }
    
    .login-form {
        padding: 1.5rem;
        border-radius: 12px;
        margin: 0.75rem 0;
    }
    
    .form-input :deep(.v-field) {
        min-height: 44px;
        border-radius: 10px;
    }
    
    .form-input :deep(.v-field__input) {
        padding: 0.75rem;
        font-size: 1rem;
    }
    
    .form-input :deep(.v-label) {
        font-size: 0.9rem;
    }
    
    .form-input :deep(.v-field__prepend-inner) {
        font-size: 1.125rem;
        margin-right: 0.875rem;
    }
    
    .signin-btn {
        min-height: 44px !important;
        font-size: 1rem !important;
        border-radius: 10px !important;
        margin: 1rem 0;
    }
}

/* Very small screens */
@media (max-width: 360px) {
    .login-column {
        padding: 1.25rem 1rem 1rem;
    }
    
    .login-form {
        padding: 1.25rem;
        border-radius: 10px;
        margin: 0.5rem 0;
    }
    
    .form-input :deep(.v-field) {
        min-height: 40px;
        border-radius: 8px;
    }
    
    .form-input :deep(.v-field__input) {
        padding: 0.625rem;
        font-size: 0.95rem;
    }
    
    .form-input :deep(.v-label) {
        font-size: 0.85rem;
    }
    
    .form-input :deep(.v-field__prepend-inner) {
        font-size: 1rem;
        margin-right: 0.75rem;
    }
    
    .signin-btn {
        min-height: 40px !important;
        font-size: 0.95rem !important;
        border-radius: 8px !important;
        margin: 0.75rem 0;
    }
}
</style>